<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">CMIS</a>
  </div>
  <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select>
</div>

<div class="header-container">
  <nb-actions size="small">

    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action> 
    <nb-action class="control-item" icon="email-outline"></nb-action> -->
    <nb-action class="apps-action">
      <div #appLauncher class="app-launcher">
        <button
          type="button"
          class="app-launcher-trigger"
          [class.active]="isAppLauncherOpen"
          [attr.aria-expanded]="isAppLauncherOpen"
          aria-haspopup="dialog"
          aria-controls="application-launcher-panel"
          aria-label="Open application launcher"
          title="Applications"
          (click)="toggleAppLauncher($event)">
          <nb-icon icon="grid-outline"></nb-icon>
        </button>

        <div
          *ngIf="isAppLauncherOpen"
          class="app-launcher-backdrop"
          aria-hidden="true"
          (click)="closeAppLauncher()">
        </div>

        <section
          *ngIf="isAppLauncherOpen"
          id="application-launcher-panel"
          class="app-launcher-panel"
          role="dialog"
          aria-modal="true"
          aria-label="Application launcher">
          <div class="launcher-header">
            <div>
              <h2>Applications</h2>
              <p>Switch between your workspaces</p>
            </div>
            <button
              type="button"
              class="launcher-close"
              aria-label="Close application launcher"
              (click)="closeAppLauncher()">
              <nb-icon icon="close-outline"></nb-icon>
            </button>
          </div>

          <div class="application-grid" *ngIf="applications.length; else noApplications">
            <button
              type="button"
              class="application-card"
              [class.sso-error]="application.ssoError"
              *ngFor="let application of applications; trackBy: trackApplication"
              [disabled]="application.ssoLoading"
              (click)="openApplication(application)"
              [attr.aria-label]="'Open ' + application.name">
              <span class="application-icon" [ngClass]="'accent-' + application.accent">
                <nb-icon [icon]="application.icon"></nb-icon>
              </span>
              <span class="application-details">
                <span class="application-title-row">
                  <strong>{{ application.name }}</strong>
                  <span class="current-badge" *ngIf="application.current">Current</span>
                </span>
                <small *ngIf="!application.ssoLoading && !application.ssoError">{{ application.description }}</small>
                <small class="application-status preparing" *ngIf="application.ssoLoading">
                  Preparing secure access...
                </small>
                <small class="application-status retry" *ngIf="application.ssoError">
                  Click to retry secure access
                </small>
              </span>
              <span class="application-loader" *ngIf="application.ssoLoading" aria-hidden="true"></span>
              <nb-icon
                *ngIf="!application.ssoLoading"
                class="application-arrow"
                [icon]="application.openInNewTab && !application.current ? 'external-link-outline' : 'arrow-forward-outline'">
              </nb-icon>
            </button>
          </div>

          <ng-template #noApplications>
            <div class="launcher-empty">
              <span class="empty-icon"><nb-icon icon="grid-outline"></nb-icon></span>
              <strong>No applications available</strong>
              <p>Contact your administrator to request application access.</p>
            </div>
          </ng-template>

          <div class="launcher-footer">
            <nb-icon icon="shield-outline"></nb-icon>
            Applications are shown according to your access.
          </div>
        </section>
      </div>
    </nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <div class="user-meta" *ngIf="!userPictureOnly">
        <div class="user-full-name">{{ displayName }}</div>
        <div class="user-role-name">{{ displayRole }}</div>
      </div>
      <nb-user
      [nbContextMenu]="userMenu"
      [onlyPicture]="true"
      [name]="displayName"
      [picture]="user?.picture">
    </nb-user>
    </nb-action>
  </nb-actions>
</div>
